import { render, staticRenderFns } from "./video_tutorial.vue?vue&type=template&id=266beed2&scoped=true"
import script from "./video_tutorial.vue?vue&type=script&lang=js"
export * from "./video_tutorial.vue?vue&type=script&lang=js"
import style0 from "./video_tutorial.vue?vue&type=style&index=0&id=266beed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266beed2",
  null
  
)

export default component.exports